import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CorporateService } from 'src/app/services/corporate.service';

@Component({
  selector: 'app-update-branch-verify-level',
  templateUrl: './update-branch-verify-level.component.html',
  styleUrls: ['./update-branch-verify-level.component.css']
})
export class UpdateBranchVerifyLevelComponent implements OnInit {
  corpId: any;
  api_success: string;
  api_error: string;
  loading = false;

  constructor(private corporateService: CorporateService, @Inject(MAT_DIALOG_DATA) public data: any,
   private dialogRef: MatDialogRef<any>) { }
 
  ngOnInit() {
    this.corpId = this.data;
  }
  onConfirm() {
    this.loading = true;
    this.api_error = '';
    this.api_success = '';
    this.corporateService.updateBranchVerifyLevel(this.corpId)
    .subscribe(res => {
      this.loading = false;
      this.api_success  = 'VerifyLevel of all branches under this corporate updated successfully';
      setTimeout(() => {
        this.dialogRef.close();
      }, 2000);

    },
    (error) => {
      this.api_error = error.error;
      this.loading = false;
    });
  }

}
